import React from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router';
import { FaExclamationTriangle } from 'react-icons/fa';
import classNames from 'classnames';
import { useActualIncidentId } from '../IAP/hooks/commonHooks';

interface ApprovalAuthorityWarningProps {
  /** Custom text to display. If not provided, uses default message. */
  message?: string;
  /** Bootstrap alert variant (default: 'warning') */
  variant?: 'warning' | 'danger' | 'info';
  /** Whether to show the warning as an inline component or not */
  inline?: boolean;
  /** Additional CSS classes */
  className?: string;
}

/** Consistent warning component for users without approval authority */
const ApprovalAuthorityWarning: React.FC<ApprovalAuthorityWarningProps> = ({
  message,
  variant = 'warning',
  inline = false,
  className = '',
}) => {
  const incidentId = useActualIncidentId();

  const defaultMessage =
    "You don't have permission to approve. Please seek permission from a user with approval authority in the incident roster.";

  const displayMessage = message || defaultMessage;

  return (
    <Alert
      variant={variant}
      className={classNames(
        'd-flex align-items-center',
        {
          'mb-0': inline,
        },
        className
      )}
    >
      <FaExclamationTriangle className="me-2" size={16} />
      <div>
        {displayMessage}{' '}
        <Link
          to={`/iap/${incidentId}/settings`}
          className="alert-link fw-bold text-decoration-underline"
        >
          View incident settings
        </Link>
      </div>
    </Alert>
  );
};

export default ApprovalAuthorityWarning;
